<template>
  <div class="flex flex-col gap-y-2">
    <div
      v-for="(recording, index) in recordings"
      :key="recording.id"
    >
      <div class="flex justify-between">
        <div>
          Voice
          <BaseIcon
            name="message-question-circle"
            size="12px"
            rounded
            class="cursor-pointer text-proxify-gray-500 ml-1"
            data-testid="recording-question-icon"
          />
          <BaseTooltip
            tooltip-class="shadow-lg gap-[12px] text-proxify-gray-700"
            max-width="216px"
            :offset="[0, 4]"
          >
            <div class="flex flex-col gap-y-2">
              <div class="text-body-sm font-semibold">Question</div>
              <div
                class="text-body-xs font-normal"
                data-testid="recording-question"
              >
                {{ recording?.question }}
              </div>
            </div>
          </BaseTooltip>
        </div>
        <AudioRecordingItem :recording="recording" />
      </div>
      <BaseAudioWaveSurfer
        v-if="recording.url"
        :url="recording.url"
        :settings="{
          container: `#wavesurfer${recording.id}`,
          progressColor: '#5258fb',
        }"
        class="pt-2.5 pb-3"
        :class="{
          'border-b border-proxify-gray-200': index !== recordings.length - 1,
        }"
      />
    </div>
  </div>
</template>

<script setup>
import AudioRecordingItem from '@/components/Elements/Applicant/ApplicantInformationAudioRecordingItem.vue';
import BaseAudioWaveSurfer from '@/components/Base/BaseAudioWaveSurfer.vue';
import BaseIcon from '@/components/Base/BaseIcon.vue';
import BaseTooltip from '@/components/Base/BaseTooltip.vue';

defineProps({
  recordings: {
    type: Array,
    required: true,
  },
});
</script>
